const amoActionConst = [
  // ########### Сделки
  {
    value: 'action_add_lead',
    label: 'Добавить сделку',
    field: [
      { value: 'name', label: 'Название сделки' },
      { value: 'price', label: 'Бюджет сделки' },
      { value: 'status_id', label: 'Статус сделки' },
      { value: 'pipeline_id', label: 'Воронка' },
      { value: 'responsible_user_id', label: 'Ответственный за сделку' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'action_update_lead',
    label: 'Изменить сделку',
    field: [
      { value: 'name', label: 'Название сделки' },
      { value: 'price', label: 'Бюджет сделки' },
      { value: 'status_id', label: 'Статус сделки' },
      { value: 'pipeline_id', label: 'Воронка' },
      { value: 'responsible_user_id', label: 'Ответственный за сделку' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'action_note_lead',
    label: 'Добавить примечание в сделку',
    field: [],
  },
  {
    value: 'action_status_lead',
    label: 'Сменить статус сделки',
    field: [
      { value: 'name', label: 'Название сделки' },
      { value: 'price', label: 'Бюджет сделки' },
      { value: 'status_id', label: 'Статус сделки' },
      { value: 'pipeline_id', label: 'Воронка' },
      { value: 'responsible_user_id', label: 'Ответственный за сделку' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'action_restore_lead',
    label: 'Восстановить сделку из удаленных',
    field: [
      { value: 'name', label: 'Название сделки' },
      { value: 'price', label: 'Бюджет сделки' },
      { value: 'status_id', label: 'Статус сделки' },
      { value: 'pipeline_id', label: 'Воронка' },
      { value: 'responsible_user_id', label: 'Ответственный за сделку' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'action_responsible_lead',
    label: 'Сменить ответственного сделки',
    field: [
      { value: 'name', label: 'Название сделки' },
      { value: 'price', label: 'Бюджет сделки' },
      { value: 'status_id', label: 'Статус сделки' },
      { value: 'pipeline_id', label: 'Воронка' },
      { value: 'responsible_user_id', label: 'Ответственный за сделку' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  // ########### Контакты
  {
    value: 'action_add_contact',
    label: 'Добавить контакт',
    field: [
      { value: 'name', label: 'Название контакта' },
      { value: 'first_name', label: 'Имя контакта' },
      { value: 'last_name', label: 'Фамилия контакта' },
      { value: 'responsible_user_id', label: 'Ответственный за контакт' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'action_update_contact',
    label: 'Изменить контакт',
    field: [
      { value: 'name', label: 'Название контакта' },
      { value: 'first_name', label: 'Имя контакта' },
      { value: 'last_name', label: 'Фамилия контакта' },
      { value: 'responsible_user_id', label: 'Ответственный за контакт' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'action_note_contact',
    label: 'Добавить примечание в контакт',
    field: [],
  },
  {
    value: 'action_restore_contact',
    label: 'Восстановить контакт из удаленных',
    field: [
      { value: 'name', label: 'Название контакта' },
      { value: 'first_name', label: 'Имя контакта' },
      { value: 'last_name', label: 'Фамилия контакта' },
      { value: 'responsible_user_id', label: 'Ответственный за контакт' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'action_responsible_contact',
    label: 'Сменить ответственного контакта',
    field: [
      { value: 'name', label: 'Название контакта' },
      { value: 'first_name', label: 'Имя контакта' },
      { value: 'last_name', label: 'Фамилия контакта' },
      { value: 'responsible_user_id', label: 'Ответственный за контакт' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  // ########### Задачи
  {
    value: 'action_add_task',
    label: 'Добавить задачу',
    field: [
      { value: 'responsible_user_id', label: 'Ответственный за задачу' },
      { value: 'text', label: 'Описание задачи' },
      { value: 'complete_till', label: 'Дата завершения задачи' },
    ],
  },
  {
    value: 'action_update_task',
    label: 'Изменить задачу',
    field: [
      { value: 'responsible_user_id', label: 'Ответственный за задачу' },
      { value: 'text', label: 'Описание задачи' },
      { value: 'complete_till', label: 'Дата завершения задачи' },
    ],
  },
  {
    value: 'action_responsible_task',
    label: 'Сменить ответственного задачи',
    field: [
      { value: 'responsible_user_id', label: 'Ответственный за задачу' },
      { value: 'text', label: 'Описание задачи' },
      { value: 'complete_till', label: 'Дата завершения задачи' },
    ],
  },
  // ########### Компании
  // { value: 'action_add_company', label: 'Добавить компании' },
  // { value: 'action_update_company', label: 'Изменить компанию' },
  // { value: 'action_note_company', label: 'Добавить примечание в компанию' },
  // { value: 'action_delete_company', label: 'Удалить компанию' },
  // {
  //   value: 'action_restore_company',
  //   label: 'Восстановить компанию из удаленных',
  // },
  // {
  //   value: 'action_responsible_company',
  //   label: 'Сменить ответственного компании',
  // },
  // ########### Беседы
  //   { value: 'add_talk', label: 'Добавлена беседа' },
  //   { value: 'update_talk', label: 'Беседа изменена' },
  // ########### ?
  //   { value: 'add_message', label: 'add_message' },
  // ########### Покупатели
  //   { value: 'add_customer', label: 'Добавлен покупатель' },
  //   { value: 'update_customer', label: 'Покупатель изменен' },
  //   { value: 'note_customer', label: 'Примечание добавлено в покупателя' },
  //   { value: 'delete_customer', label: 'Удален покупатель' },
  //   {
  //     value: 'responsible_customer',
  //     label: 'У покупателя сменился ответственный',
  //   },
  // ########### ?
  //   { value: 'add_unsorted', label: 'add_unsorted' },
  //   { value: 'update_unsorted', label: 'update_unsorted' },
  //   { value: 'delete_unsorted', label: 'delete_unsorted' },
]

export default amoActionConst
